import { render, staticRenderFns } from "./StudyInstructions.vue?vue&type=template&id=437c5971&scoped=true"
import script from "./StudyInstructions.vue?vue&type=script&lang=js"
export * from "./StudyInstructions.vue?vue&type=script&lang=js"
import style0 from "./StudyInstructions.vue?vue&type=style&index=0&id=437c5971&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "437c5971",
  null
  
)

export default component.exports